import { Conforme, DatatableMessage, Page } from "../../models/api.models";

export class ConformeData {
    conformes: Conforme[];
    page: Page;
    loading: boolean;
    msg: DatatableMessage;
}